import {Provider} from "@angular/core";
import {TEST_MODULE_REGISTRY, TestModuleDefinition} from "../../../core/shared/test/data/test-harness.types";
import {CsConfigPage} from "../page/overview/cs-config-page/cs-config.page";


const csModuleEntry: TestModuleDefinition = {
    key: 'cs',
    label: 'Referal (cs)',
    components: [
        {
            key: 'CsConfigPage',
            component: CsConfigPage,
            selector: 'cs-config-page',
            type: 'PageComponent',
            label: 'cs config page'
        },
    ]
}

export const CS_TEST_PROVIDERS: Provider[] = [
    {provide: TEST_MODULE_REGISTRY, useValue: csModuleEntry, multi: true}
];